import React from 'react'
import Logo from "../components/Logo"
import { Link } from 'react-router-dom'
import CloseIcon from "../components/Svg/CloseIcon"

function MobileMenu(props) {
  return (
    <div className={props.className} >
    <div className="mobile-menu-top">
    <Logo />
    <div className="close-group" onClick={props.onClick}>
    <CloseIcon className="close-icon" fill='#60B0F4'/>
    </div>
    </div>
    <div className="mobile-links-group">
    <div className="mobile-links-wrapper">
      <a href='#solutions' className="header-link mobile-link" onClick={props.onClick} >Our Solutions</a>
      <a href='#cases'  className="header-link mobile-link" onClick={props.onClick}>Use Cases</a>
      <a href='#pricing'  className="header-link mobile-link" onClick={props.onClick}>Pricing</a>
    </div>
    <div className="mobile-entry">
      <Link to='/login' className="mobile-signin-link">Sign In</Link>
      <Link to='/signup' className="header-signup-btn mobile-btn">Create Account</Link>
    </div>
    </div>
    </div>
  )
}

export default MobileMenu